module.exports = "/_next/static/public/images/022f0d6800d3699bdf02045109aa65f6-1e5bb1cbf6ae95df47efc9dc41120fa4.png";